import { QueryClient } from "@tanstack/query-core";
import { Route } from "react-router-dom";
import { SetErrorMessageType } from "@/app/providers/ReactContextProvider/types";
import { cabinetLoader } from "@/router/loaders/cabinetLoader";
import { RouterPath } from "@/router/types";
import { PageSpinner } from "@/shared/ui/PageSpinner";
import { LayoutCabinet } from "@/widgets/Layout/Cabinet";

export const cabinetRouter = (
  queryClient: QueryClient,
  setErrorMessage: SetErrorMessageType,
) => (
  <Route element={<LayoutCabinet />} HydrateFallback={PageSpinner}>
    <Route
      path={RouterPath.Cabinet}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/Cabinet")}
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.Profile}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/Profile")}
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.History}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/History")}
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.LoanRepeat}
      loader={cabinetLoader(queryClient, setErrorMessage)}
      lazy={() => import(/* webpackPrefetch: true */ "@/pages/LoanRepeat")}
      HydrateFallback={PageSpinner}
    />
  </Route>
);
